const O = /* @__PURE__ */ new Set([
  "m",
  "me",
  "men",
  "mrow",
  "c",
  "pre",
  "cline",
  "input",
  "output",
  "prompt"
]);
function D(e) {
  return !("children" in e) || !Array.isArray(e.children) ? "" : e.children.filter((i) => i.type === "text").map((i) => i.value).join("");
}
const g = {
  abbr: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  abstract: {
    elements: [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:id"
    ]
  },
  acknowledgement: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "idx",
      "image",
      "p",
      "paragraphs",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  acro: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  activity: {
    elements: [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    attributes: [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  ad: {
    elements: [],
    attributes: []
  },
  address: {
    elements: [],
    attributes: []
  },
  affiliation: {
    elements: [
      "department",
      "institution",
      "location"
    ],
    attributes: []
  },
  alert: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  algorithm: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  alteration: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "flat",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  am: {
    elements: [],
    attributes: []
  },
  angles: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  answer: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  appendix: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "notation-list",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "section",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subsection",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  archive: {
    elements: [],
    attributes: [
      "from"
    ]
  },
  area: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "correct"
    ]
  },
  areas: {
    elements: [
      "p"
    ],
    attributes: []
  },
  argument: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  article: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "backmatter",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "frontmatter",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "section",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subtitle",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  articletitle: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  aside: {
    elements: [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  assemblage: {
    elements: [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  assumption: {
    elements: [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  asymptote: {
    elements: [],
    attributes: [
      "component",
      "label"
    ]
  },
  "asymptote-preamble": {
    elements: [],
    attributes: []
  },
  attr: {
    elements: [],
    attributes: []
  },
  attribution: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  author: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "affiliation",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "biography",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "department",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "institution",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "location",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "personname",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "support",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "corresponding",
      "halign",
      "xml:id"
    ]
  },
  "author-biographies": {
    elements: [],
    attributes: [
      "length"
    ]
  },
  axiom: {
    elements: [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  backmatter: {
    elements: [
      "appendix",
      "colophon",
      "idx",
      "index",
      "references",
      "solutions",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  bc: {
    elements: [],
    attributes: []
  },
  bibinfo: {
    elements: [
      "author",
      "copyright",
      "credit",
      "date",
      "edition",
      "editor",
      "keywords",
      "support",
      "website"
    ],
    attributes: []
  },
  biblio: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "author",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "editor",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "ibid",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "journal",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "note",
      "number",
      "obelus",
      "pages",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "publisher",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "series",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "title",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "volume",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref",
      "year"
    ],
    attributes: [
      "component",
      "label",
      "type",
      "xml:id"
    ]
  },
  biographical: {
    elements: [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  biography: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "idx",
      "image",
      "p",
      "paragraphs",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  block: {
    elements: [
      "blockquote",
      "choice",
      "cline",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: [
      "correct",
      "order"
    ]
  },
  blockquote: {
    elements: [
      "attribution",
      "idx",
      "p",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  blocks: {
    elements: [
      "block"
    ],
    attributes: [
      "layout",
      "randomize"
    ]
  },
  blurb: {
    elements: [],
    attributes: [
      "shelf"
    ]
  },
  book: {
    elements: [
      "backmatter",
      "chapter",
      "frontmatter",
      "handout",
      "idx",
      "part",
      "plaintitle",
      "shorttitle",
      "subtitle",
      "title",
      "worksheet"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  brandlogo: {
    elements: [],
    attributes: [
      "source",
      "url"
    ]
  },
  c: {
    elements: [],
    attributes: []
  },
  ca: {
    elements: [],
    attributes: []
  },
  caption: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  case: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "direction",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  cd: {
    elements: [
      "cline"
    ],
    attributes: [
      "latexsep"
    ]
  },
  cell: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "p",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "bottom",
      "colspan",
      "halign",
      "right"
    ]
  },
  chapter: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "section",
      "shorttitle",
      "sidebyside",
      "solutions",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  checkpoint: {
    elements: [
      "feedback",
      "prompt"
    ],
    attributes: [
      "answer",
      "answer-variable",
      "line"
    ]
  },
  choice: {
    elements: [
      "blockquote",
      "cline",
      "console",
      "feedback",
      "image",
      "p",
      "pre",
      "program",
      "statement",
      "tabular",
      "video"
    ],
    attributes: [
      "correct"
    ]
  },
  choices: {
    elements: [
      "choice"
    ],
    attributes: [
      "randomize"
    ]
  },
  chord: {
    elements: [
      "alteration"
    ],
    attributes: [
      "bass",
      "bps",
      "mode",
      "parentheses",
      "root",
      "suspended"
    ]
  },
  claim: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  cline: {
    elements: [],
    attributes: []
  },
  code: {
    elements: [],
    attributes: []
  },
  col: {
    elements: [],
    attributes: [
      "halign",
      "right",
      "top",
      "width"
    ]
  },
  colophon: {
    elements: [
      "blockquote",
      "colophon-items",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:id"
    ]
  },
  "colophon-items": {
    elements: [],
    attributes: []
  },
  computation: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  conclusion: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  conjecture: {
    elements: [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  console: {
    elements: [
      "input",
      "output"
    ],
    attributes: [
      "component",
      "continuation",
      "margins",
      "prompt",
      "width"
    ]
  },
  contributor: {
    elements: [
      "affiliation",
      "department",
      "email",
      "idx",
      "institution",
      "location",
      "personname"
    ],
    attributes: [
      "component",
      "label",
      "xml:id"
    ]
  },
  contributors: {
    elements: [
      "contributor"
    ],
    attributes: []
  },
  convention: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  copyleft: {
    elements: [],
    attributes: []
  },
  copyright: {
    elements: [
      "holder",
      "minilicense",
      "shortlicense",
      "year"
    ],
    attributes: []
  },
  corollary: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  creator: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  credit: {
    elements: [
      "author",
      "entity",
      "role",
      "title"
    ],
    attributes: []
  },
  "cross-references": {
    elements: [],
    attributes: [
      "text"
    ]
  },
  data: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  date: {
    elements: [
      "ad",
      "am",
      "bc",
      "ca",
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "eg",
      "ellipsis",
      "etal",
      "etc",
      "fillin",
      "icon",
      "ie",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "tex",
      "timeofday",
      "times",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  dblbrackets: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  dblprime: {
    elements: [],
    attributes: []
  },
  dedication: {
    elements: [
      "idx",
      "p",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  definition: {
    elements: [
      "idx",
      "notation",
      "statement",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  degree: {
    elements: [],
    attributes: []
  },
  delete: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  department: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  description: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "p",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tabular",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  division: {
    elements: [],
    attributes: [
      "part"
    ]
  },
  dl: {
    elements: [
      "li"
    ],
    attributes: [
      "component",
      "width"
    ]
  },
  docinfo: {
    elements: [
      "asymptote-preamble",
      "author-biographies",
      "blurb",
      "brandlogo",
      "cross-references",
      "document-id",
      "feedback",
      "images",
      "initialism",
      "latex-image-preamble",
      "macros",
      "math-package",
      "numbering",
      "parsons",
      "programs",
      "rename"
    ],
    attributes: [
      "xml:base",
      "xml:lang"
    ]
  },
  "document-id": {
    elements: [],
    attributes: [
      "edition"
    ]
  },
  doubleflat: {
    elements: [],
    attributes: []
  },
  doublesharp: {
    elements: [],
    attributes: []
  },
  edition: {
    elements: [],
    attributes: []
  },
  editor: {
    elements: [
      "affiliation",
      "department",
      "email",
      "institution",
      "location",
      "personname"
    ],
    attributes: []
  },
  eg: {
    elements: [],
    attributes: []
  },
  ellipsis: {
    elements: [],
    attributes: []
  },
  em: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  email: {
    elements: [],
    attributes: []
  },
  entity: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  etal: {
    elements: [],
    attributes: []
  },
  etc: {
    elements: [],
    attributes: []
  },
  event: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  example: {
    elements: [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  exercise: {
    elements: [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "pre",
      "preamble",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    attributes: [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "workspace",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  exercisegroup: {
    elements: [
      "conclusion",
      "exercise",
      "idx",
      "introduction",
      "title"
    ],
    attributes: [
      "cols",
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  exercises: {
    elements: [
      "conclusion",
      "exercise",
      "exercisegroup",
      "idx",
      "interactive",
      "introduction",
      "plaintitle",
      "shorttitle",
      "subexercises",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  explanation: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  exploration: {
    elements: [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    attributes: [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  fact: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  feedback: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "url",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  figure: {
    elements: [
      "caption",
      "idx",
      "image",
      "interactive",
      "sbsgroup",
      "score",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  fillin: {
    elements: [],
    attributes: [
      "characters",
      "cols",
      "fill",
      "rows"
    ]
  },
  flat: {
    elements: [],
    attributes: []
  },
  fn: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "component",
      "label",
      "xml:id"
    ]
  },
  foreign: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "xml:lang"
    ]
  },
  fragment: {
    elements: [
      "code",
      "fragref",
      "title"
    ],
    attributes: [
      "filename",
      "xml:id"
    ]
  },
  fragref: {
    elements: [],
    attributes: [
      "ref"
    ]
  },
  frontmatter: {
    elements: [
      "abstract",
      "acknowledgement",
      "bibinfo",
      "biography",
      "colophon",
      "dedication",
      "idx",
      "preface",
      "title",
      "titlepage"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  genus: {
    elements: [],
    attributes: []
  },
  gi: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  glossary: {
    elements: [
      "gi",
      "headnote",
      "idx",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  h: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: [
      "sortby"
    ]
  },
  handout: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "page",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    attributes: [
      "bottom",
      "component",
      "label",
      "left",
      "margin",
      "right",
      "top",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  headnote: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "historical",
      "image",
      "p",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "video"
    ],
    attributes: []
  },
  heuristic: {
    elements: [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  hint: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  historical: {
    elements: [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  holder: {
    elements: [],
    attributes: []
  },
  hypothesis: {
    elements: [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  ibid: {
    elements: [],
    attributes: []
  },
  icon: {
    elements: [],
    attributes: [
      "name"
    ]
  },
  identity: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  idx: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "h",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "see",
      "seealso",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: [
      "component",
      "finish",
      "label",
      "sortby",
      "start",
      "xml:id"
    ]
  },
  ie: {
    elements: [],
    attributes: []
  },
  image: {
    elements: [
      "asymptote",
      "description",
      "latex-image",
      "sageplot",
      "shortdescription"
    ],
    attributes: [
      "archive",
      "component",
      "decorative",
      "margins",
      "pg-name",
      "rotate",
      "source",
      "width",
      "xml:id"
    ]
  },
  images: {
    elements: [
      "archive"
    ],
    attributes: []
  },
  index: {
    elements: [
      "idx",
      "index-list",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "index-list": {
    elements: [],
    attributes: []
  },
  init: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  initialism: {
    elements: [],
    attributes: []
  },
  input: {
    elements: [],
    attributes: [
      "continuation",
      "onclick",
      "onkeypress",
      "prompt",
      "style",
      "type",
      "value"
    ]
  },
  insert: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  insight: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  institution: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  instruction: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  instructions: {
    elements: [
      "blockquote",
      "console",
      "idx",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  interactive: {
    elements: [
      "instructions",
      "sbsgroup",
      "sidebyside",
      "slate",
      "static"
    ],
    attributes: [
      "aspect",
      "component",
      "iframe",
      "label",
      "platform",
      "preview",
      "source",
      "version",
      "width",
      "xml:id"
    ]
  },
  interlude: {
    elements: [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: []
  },
  intertext: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  introduction: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  investigation: {
    elements: [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    attributes: [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  iotest: {
    elements: [
      "input",
      "output"
    ],
    attributes: []
  },
  journal: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  justification: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  kbd: {
    elements: [],
    attributes: [
      "name"
    ]
  },
  keyword: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: [
      "primary"
    ]
  },
  keywords: {
    elements: [
      "keyword",
      "title"
    ],
    attributes: [
      "authority",
      "variant"
    ]
  },
  langle: {
    elements: [],
    attributes: []
  },
  latex: {
    elements: [],
    attributes: []
  },
  "latex-image": {
    elements: [],
    attributes: [
      "component",
      "label"
    ]
  },
  "latex-image-preamble": {
    elements: [],
    attributes: []
  },
  ldblbracket: {
    elements: [],
    attributes: []
  },
  lemma: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  letter: {
    elements: [],
    attributes: []
  },
  li: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "aside",
      "attr",
      "bc",
      "biographical",
      "blockquote",
      "c",
      "ca",
      "cd",
      "chord",
      "console",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "dl",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "figure",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "historical",
      "icon",
      "idx",
      "ie",
      "image",
      "init",
      "insert",
      "interactive",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "list",
      "listing",
      "lq",
      "lsq",
      "m",
      "md",
      "mdash",
      "mdn",
      "me",
      "men",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "notation",
      "obelus",
      "ol",
      "p",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "pre",
      "prefigure",
      "pretext",
      "prime",
      "program",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "sage",
      "sbsgroup",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "sidebyside",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "table",
      "tabular",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "title",
      "today",
      "trademark",
      "ul",
      "url",
      "var",
      "video",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  line: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "indent"
    ]
  },
  list: {
    elements: [
      "conclusion",
      "dl",
      "idx",
      "introduction",
      "ol",
      "plaintitle",
      "shorttitle",
      "title",
      "ul"
    ],
    attributes: [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "list-of": {
    elements: [],
    attributes: [
      "divisions",
      "elements",
      "empty",
      "scope"
    ]
  },
  listing: {
    elements: [
      "console",
      "idx",
      "plaintitle",
      "program",
      "shorttitle",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  location: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  lq: {
    elements: [],
    attributes: []
  },
  lsq: {
    elements: [],
    attributes: []
  },
  m: {
    elements: [
      "fillin",
      "var"
    ],
    attributes: []
  },
  "macro-file": {
    elements: [],
    attributes: []
  },
  macros: {
    elements: [],
    attributes: []
  },
  mag: {
    elements: [],
    attributes: []
  },
  match: {
    elements: [
      "premise",
      "response"
    ],
    attributes: [
      "order"
    ]
  },
  matches: {
    elements: [
      "match"
    ],
    attributes: []
  },
  "math-package": {
    elements: [],
    attributes: [
      "latex-name",
      "mathjax-name"
    ]
  },
  md: {
    elements: [
      "fillin",
      "intertext",
      "mrow",
      "var",
      "xref"
    ],
    attributes: [
      "alignat-columns",
      "alignment",
      "break",
      "number"
    ]
  },
  mdash: {
    elements: [],
    attributes: []
  },
  mdn: {
    elements: [
      "fillin",
      "intertext",
      "mrow",
      "var"
    ],
    attributes: [
      "alignat-columns",
      "alignment",
      "break",
      "number"
    ]
  },
  me: {
    elements: [
      "fillin",
      "idx",
      "var",
      "xref"
    ],
    attributes: [
      "component",
      "label",
      "xml:id"
    ]
  },
  memo: {
    elements: [],
    attributes: []
  },
  men: {
    elements: [
      "fillin",
      "idx",
      "var",
      "xref"
    ],
    attributes: [
      "component",
      "label",
      "xml:id"
    ]
  },
  midpoint: {
    elements: [],
    attributes: []
  },
  minilicense: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  minus: {
    elements: [],
    attributes: []
  },
  mrow: {
    elements: [
      "fillin",
      "idx",
      "var",
      "xref"
    ],
    attributes: [
      "break",
      "component",
      "label",
      "number",
      "tag",
      "xml:id"
    ]
  },
  myopenmath: {
    elements: [],
    attributes: [
      "params",
      "problem"
    ]
  },
  n: {
    elements: [],
    attributes: [
      "acc",
      "octave",
      "pc"
    ]
  },
  name: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  natural: {
    elements: [],
    attributes: []
  },
  nb: {
    elements: [],
    attributes: []
  },
  nbsp: {
    elements: [],
    attributes: []
  },
  ndash: {
    elements: [],
    attributes: []
  },
  notation: {
    elements: [
      "description",
      "usage"
    ],
    attributes: []
  },
  "notation-list": {
    elements: [],
    attributes: []
  },
  note: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  number: {
    elements: [],
    attributes: []
  },
  numbering: {
    elements: [
      "division"
    ],
    attributes: []
  },
  obelus: {
    elements: [],
    attributes: []
  },
  objectives: {
    elements: [
      "conclusion",
      "dl",
      "idx",
      "introduction",
      "ol",
      "title",
      "ul"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  observation: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  ol: {
    elements: [
      "li"
    ],
    attributes: [
      "cols",
      "component",
      "marker"
    ]
  },
  outcomes: {
    elements: [
      "conclusion",
      "dl",
      "idx",
      "introduction",
      "ol",
      "title",
      "ul"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  output: {
    elements: [],
    attributes: []
  },
  p: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "area",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "cd",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "dl",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "md",
      "mdash",
      "mdn",
      "me",
      "men",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "notation",
      "obelus",
      "ol",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "ul",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: [
      "component",
      "label",
      "xml:id"
    ]
  },
  page: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "video",
      "warning"
    ],
    attributes: []
  },
  pages: {
    elements: [],
    attributes: [
      "end",
      "start"
    ]
  },
  paragraphs: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "observation",
      "p",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  parsons: {
    elements: [],
    attributes: [
      "language"
    ]
  },
  part: {
    elements: [
      "chapter",
      "idx",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  per: {
    elements: [],
    attributes: [
      "base",
      "exp",
      "prefix"
    ]
  },
  permille: {
    elements: [],
    attributes: []
  },
  personname: {
    elements: [
      "copyleft",
      "copyright",
      "dblprime",
      "degree",
      "ellipsis",
      "icon",
      "kbd",
      "langle",
      "ldblbracket",
      "lq",
      "lsq",
      "mdash",
      "midpoint",
      "minus",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "phonomark",
      "pilcrow",
      "plusminus",
      "prime",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "section-mark",
      "servicemark",
      "solidus",
      "swungdash",
      "times",
      "trademark"
    ],
    attributes: []
  },
  pf: {
    elements: [],
    attributes: [
      "language"
    ]
  },
  "pg-code": {
    elements: [],
    attributes: []
  },
  "pg-macros": {
    elements: [
      "macro-file"
    ],
    attributes: []
  },
  phonomark: {
    elements: [],
    attributes: []
  },
  pilcrow: {
    elements: [],
    attributes: []
  },
  plaintitle: {
    elements: [],
    attributes: []
  },
  plusminus: {
    elements: [],
    attributes: []
  },
  pm: {
    elements: [],
    attributes: []
  },
  poem: {
    elements: [
      "author",
      "idx",
      "line",
      "stanza",
      "title"
    ],
    attributes: [
      "component",
      "halign",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  postamble: {
    elements: [],
    attributes: [
      "indent",
      "visible"
    ]
  },
  postlude: {
    elements: [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: []
  },
  pre: {
    elements: [
      "cline"
    ],
    attributes: []
  },
  preamble: {
    elements: [],
    attributes: [
      "indent",
      "visible"
    ]
  },
  preface: {
    elements: [
      "aside",
      "attribution",
      "biographical",
      "blockquote",
      "console",
      "contributors",
      "historical",
      "idx",
      "image",
      "p",
      "paragraphs",
      "pre",
      "program",
      "sbsgroup",
      "sidebyside",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  prefigure: {
    elements: [],
    attributes: []
  },
  prelude: {
    elements: [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: []
  },
  premise: {
    elements: [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: []
  },
  pretext: {
    elements: [
      "article",
      "book",
      "docinfo",
      "letter",
      "memo"
    ],
    attributes: [
      "xml:lang"
    ]
  },
  prime: {
    elements: [],
    attributes: []
  },
  principle: {
    elements: [
      "creator",
      "idx",
      "statement",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  problem: {
    elements: [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  program: {
    elements: [
      "checkpoint",
      "code",
      "postamble",
      "preamble",
      "stdin",
      "tests"
    ],
    attributes: [
      "add-files",
      "autorun",
      "chatcodes",
      "codelens",
      "compile-also",
      "compiler-args",
      "component",
      "database",
      "download",
      "extra-compiler-args",
      "filename",
      "hidecode",
      "highlight-lines",
      "include",
      "interactive",
      "interpreter-args",
      "label",
      "language",
      "line-numbers",
      "linker-args",
      "margins",
      "starting-step",
      "timelimit",
      "width",
      "xml:id"
    ]
  },
  programs: {
    elements: [],
    attributes: [
      "compiler-args",
      "download",
      "interpreter-args",
      "language",
      "linenumbers",
      "linker-args",
      "timeout"
    ]
  },
  project: {
    elements: [
      "answer",
      "areas",
      "aside",
      "biographical",
      "blockquote",
      "blocks",
      "choices",
      "conclusion",
      "console",
      "feedback",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "matches",
      "myopenmath",
      "ol",
      "p",
      "postamble",
      "postlude",
      "pre",
      "preamble",
      "prelude",
      "program",
      "response",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video",
      "webwork"
    ],
    attributes: [
      "adaptive",
      "attachment",
      "component",
      "indentation",
      "label",
      "language",
      "number",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  prompt: {
    elements: [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: []
  },
  proof: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  proposition: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  ps: {
    elements: [],
    attributes: []
  },
  publisher: {
    elements: [],
    attributes: []
  },
  pubtitle: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  q: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "area",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  quantity: {
    elements: [
      "mag",
      "per",
      "unit"
    ],
    attributes: []
  },
  question: {
    elements: [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  rangle: {
    elements: [],
    attributes: []
  },
  rdblbracket: {
    elements: [],
    attributes: []
  },
  "reading-questions": {
    elements: [
      "conclusion",
      "exercise",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  reasoning: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "case",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  references: {
    elements: [
      "biblio",
      "conclusion",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  registered: {
    elements: [],
    attributes: []
  },
  remark: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  rename: {
    elements: [],
    attributes: [
      "element",
      "xml:lang"
    ]
  },
  response: {
    elements: [
      "blockquote",
      "console",
      "image",
      "p",
      "pre",
      "program",
      "tabular",
      "video"
    ],
    attributes: []
  },
  role: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  row: {
    elements: [
      "cell"
    ],
    attributes: [
      "bottom",
      "halign",
      "header",
      "left",
      "valign"
    ]
  },
  rq: {
    elements: [],
    attributes: []
  },
  rsq: {
    elements: [],
    attributes: []
  },
  sage: {
    elements: [
      "input",
      "output"
    ],
    attributes: [
      "auto-evaluate",
      "component",
      "doctest",
      "language",
      "tolerance",
      "type"
    ]
  },
  sageplot: {
    elements: [],
    attributes: [
      "aspect",
      "component",
      "label",
      "variant"
    ]
  },
  sbsgroup: {
    elements: [
      "sidebyside"
    ],
    attributes: [
      "component",
      "margins",
      "valign",
      "valigns",
      "width",
      "widths"
    ]
  },
  scaledeg: {
    elements: [],
    attributes: []
  },
  score: {
    elements: [],
    attributes: [
      "musescore",
      "musescoreuser"
    ]
  },
  section: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subsection",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  "section-mark": {
    elements: [],
    attributes: []
  },
  see: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  seealso: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  series: {
    elements: [],
    attributes: []
  },
  servicemark: {
    elements: [],
    attributes: []
  },
  sharp: {
    elements: [],
    attributes: []
  },
  shortdescription: {
    elements: [
      "var"
    ],
    attributes: []
  },
  shortlicense: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  shorttitle: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  },
  sidebyside: {
    elements: [
      "console",
      "dl",
      "exercise",
      "figure",
      "image",
      "interactive",
      "list",
      "listing",
      "ol",
      "p",
      "poem",
      "pre",
      "program",
      "slate",
      "stack",
      "table",
      "tabular",
      "task",
      "ul",
      "video"
    ],
    attributes: [
      "component",
      "margins",
      "valign",
      "valigns",
      "width",
      "widths"
    ]
  },
  slate: {
    elements: [
      "input",
      "p",
      "sidebyside",
      "tabular",
      "xhtml:button"
    ],
    attributes: [
      "aspect",
      "axis",
      "component",
      "grid",
      "label",
      "material",
      "source",
      "surface",
      "xml:id"
    ]
  },
  solidus: {
    elements: [],
    attributes: []
  },
  solution: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  solutions: {
    elements: [
      "conclusion",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    attributes: [
      "admit",
      "component",
      "divisional",
      "inline",
      "label",
      "project",
      "reading",
      "scope",
      "worksheet",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  species: {
    elements: [],
    attributes: []
  },
  sq: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "area",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  stack: {
    elements: [
      "console",
      "dl",
      "image",
      "ol",
      "p",
      "pre",
      "program",
      "slate",
      "tabular",
      "ul",
      "video"
    ],
    attributes: []
  },
  stale: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  stanza: {
    elements: [
      "idx",
      "line",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  statement: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "image",
      "instruction",
      "interactive",
      "list",
      "listing",
      "ol",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "video"
    ],
    attributes: [
      "correct"
    ]
  },
  static: {
    elements: [
      "image"
    ],
    attributes: []
  },
  stdin: {
    elements: [],
    attributes: []
  },
  subexercises: {
    elements: [
      "conclusion",
      "exercise",
      "exercisegroup",
      "idx",
      "introduction",
      "plaintitle",
      "shorttitle",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  subsection: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "solutions",
      "subsubsection",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  subsubsection: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "author",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "exercises",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "glossary",
      "handout",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "paragraphs",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reading-questions",
      "reasoning",
      "references",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "solutions",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning",
      "worksheet"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  subtitle: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  support: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "cd",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "dl",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "fn",
      "foreign",
      "icon",
      "idx",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "md",
      "mdash",
      "mdn",
      "me",
      "men",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "notation",
      "obelus",
      "ol",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "ul",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  swungdash: {
    elements: [],
    attributes: []
  },
  table: {
    elements: [
      "idx",
      "plaintitle",
      "shorttitle",
      "tabular",
      "title"
    ],
    attributes: [
      "component",
      "label",
      "landscape",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  tabular: {
    elements: [
      "col",
      "row"
    ],
    attributes: [
      "bottom",
      "component",
      "halign",
      "left",
      "margins",
      "right",
      "row-headers",
      "top",
      "valign",
      "width"
    ]
  },
  tag: {
    elements: [],
    attributes: []
  },
  tage: {
    elements: [],
    attributes: []
  },
  task: {
    elements: [
      "answer",
      "aside",
      "biographical",
      "blockquote",
      "conclusion",
      "console",
      "figure",
      "hint",
      "historical",
      "idx",
      "image",
      "interactive",
      "introduction",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "solution",
      "statement",
      "table",
      "tabular",
      "task",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "workspace",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  taxon: {
    elements: [
      "genus",
      "species"
    ],
    attributes: [
      "ncbi"
    ]
  },
  technology: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  term: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  tests: {
    elements: [
      "iotest"
    ],
    attributes: [
      "visible"
    ]
  },
  tex: {
    elements: [],
    attributes: []
  },
  theorem: {
    elements: [
      "argument",
      "aside",
      "biographical",
      "blockquote",
      "console",
      "creator",
      "explanation",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "justification",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "proof",
      "reasoning",
      "sage",
      "sbsgroup",
      "sidebyside",
      "statement",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  timeofday: {
    elements: [],
    attributes: []
  },
  times: {
    elements: [],
    attributes: []
  },
  timesignature: {
    elements: [],
    attributes: [
      "bottom",
      "top"
    ]
  },
  title: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "line",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "url",
      "var",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex",
      "xref"
    ],
    attributes: []
  },
  titlepage: {
    elements: [
      "titlepage-items"
    ],
    attributes: []
  },
  "titlepage-items": {
    elements: [],
    attributes: []
  },
  today: {
    elements: [],
    attributes: []
  },
  trademark: {
    elements: [],
    attributes: []
  },
  ul: {
    elements: [
      "li"
    ],
    attributes: [
      "cols",
      "component",
      "marker"
    ]
  },
  unit: {
    elements: [],
    attributes: [
      "base",
      "exp",
      "prefix"
    ]
  },
  url: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: [
      "href",
      "visual"
    ]
  },
  usage: {
    elements: [
      "m"
    ],
    attributes: []
  },
  var: {
    elements: [],
    attributes: [
      "category",
      "evaluator",
      "form",
      "name",
      "width"
    ]
  },
  video: {
    elements: [],
    attributes: [
      "aspect",
      "component",
      "end",
      "href",
      "label",
      "margins",
      "play-at",
      "preview",
      "source",
      "start",
      "vimeo",
      "width",
      "xml:id",
      "youtube",
      "youtubeplaylist"
    ]
  },
  viz: {
    elements: [],
    attributes: []
  },
  volume: {
    elements: [],
    attributes: []
  },
  vs: {
    elements: [],
    attributes: []
  },
  warning: {
    elements: [
      "aside",
      "biographical",
      "blockquote",
      "console",
      "figure",
      "historical",
      "idx",
      "image",
      "interactive",
      "list",
      "listing",
      "p",
      "pre",
      "program",
      "sage",
      "sbsgroup",
      "sidebyside",
      "table",
      "tabular",
      "title",
      "video"
    ],
    attributes: [
      "component",
      "label",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  website: {
    elements: [
      "address",
      "name",
      "url"
    ],
    attributes: []
  },
  webwork: {
    elements: [
      "conclusion",
      "description",
      "hint",
      "introduction",
      "pg-code",
      "pg-macros",
      "solution",
      "statement",
      "task"
    ],
    attributes: [
      "component",
      "copy",
      "label",
      "seed",
      "source",
      "xml:id"
    ]
  },
  worksheet: {
    elements: [
      "activity",
      "algorithm",
      "argument",
      "aside",
      "assemblage",
      "assumption",
      "axiom",
      "biographical",
      "blockquote",
      "claim",
      "computation",
      "conclusion",
      "conjecture",
      "console",
      "convention",
      "corollary",
      "data",
      "definition",
      "example",
      "exercise",
      "explanation",
      "exploration",
      "fact",
      "figure",
      "fragment",
      "heuristic",
      "historical",
      "hypothesis",
      "identity",
      "idx",
      "image",
      "insight",
      "interactive",
      "introduction",
      "investigation",
      "justification",
      "lemma",
      "list",
      "list-of",
      "listing",
      "note",
      "objectives",
      "observation",
      "outcomes",
      "p",
      "page",
      "plaintitle",
      "poem",
      "pre",
      "principle",
      "problem",
      "program",
      "project",
      "proof",
      "proposition",
      "question",
      "reasoning",
      "remark",
      "sage",
      "sbsgroup",
      "shorttitle",
      "sidebyside",
      "table",
      "tabular",
      "technology",
      "theorem",
      "title",
      "video",
      "warning"
    ],
    attributes: [
      "bottom",
      "component",
      "label",
      "left",
      "margin",
      "right",
      "top",
      "xml:base",
      "xml:id",
      "xml:lang"
    ]
  },
  xelatex: {
    elements: [],
    attributes: []
  },
  xetex: {
    elements: [],
    attributes: []
  },
  "xhtml:button": {
    elements: [],
    attributes: [
      "id",
      "type"
    ]
  },
  xref: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: [
      "detail",
      "first",
      "last",
      "provisional",
      "ref",
      "text"
    ]
  },
  year: {
    elements: [
      "abbr",
      "acro",
      "ad",
      "alert",
      "am",
      "angles",
      "articletitle",
      "attr",
      "bc",
      "c",
      "ca",
      "chord",
      "copyleft",
      "copyright",
      "dblbrackets",
      "dblprime",
      "degree",
      "delete",
      "doubleflat",
      "doublesharp",
      "eg",
      "ellipsis",
      "em",
      "email",
      "etal",
      "etc",
      "fillin",
      "flat",
      "foreign",
      "icon",
      "ie",
      "init",
      "insert",
      "kbd",
      "langle",
      "latex",
      "ldblbracket",
      "lq",
      "lsq",
      "m",
      "mdash",
      "midpoint",
      "minus",
      "n",
      "natural",
      "nb",
      "nbsp",
      "ndash",
      "obelus",
      "permille",
      "pf",
      "phonomark",
      "pilcrow",
      "plusminus",
      "pm",
      "prefigure",
      "pretext",
      "prime",
      "ps",
      "pubtitle",
      "q",
      "quantity",
      "rangle",
      "rdblbracket",
      "registered",
      "rq",
      "rsq",
      "scaledeg",
      "section-mark",
      "servicemark",
      "sharp",
      "solidus",
      "sq",
      "stale",
      "swungdash",
      "tag",
      "tage",
      "taxon",
      "term",
      "tex",
      "timeofday",
      "times",
      "timesignature",
      "today",
      "trademark",
      "viz",
      "vs",
      "webwork",
      "xelatex",
      "xetex"
    ],
    attributes: []
  }
}, k = [], w = [
  "abbr",
  "abstract",
  "acknowledgement",
  "acro",
  "activity",
  "ad",
  "address",
  "affiliation",
  "alert",
  "algorithm",
  "alteration",
  "am",
  "angles",
  "answer",
  "appendix",
  "archive",
  "area",
  "areas",
  "argument",
  "article",
  "articletitle",
  "aside",
  "assemblage",
  "assumption",
  "asymptote",
  "asymptote-preamble",
  "attr",
  "attribution",
  "author",
  "author-biographies",
  "axiom",
  "backmatter",
  "bc",
  "bibinfo",
  "biblio",
  "biographical",
  "biography",
  "block",
  "blockquote",
  "blocks",
  "blurb",
  "book",
  "brandlogo",
  "c",
  "ca",
  "caption",
  "case",
  "cd",
  "cell",
  "chapter",
  "checkpoint",
  "choice",
  "choices",
  "chord",
  "claim",
  "cline",
  "code",
  "col",
  "colophon",
  "colophon-items",
  "computation",
  "conclusion",
  "conjecture",
  "console",
  "contributor",
  "contributors",
  "convention",
  "copyleft",
  "copyright",
  "corollary",
  "creator",
  "credit",
  "cross-references",
  "data",
  "date",
  "dblbrackets",
  "dblprime",
  "dedication",
  "definition",
  "degree",
  "delete",
  "department",
  "description",
  "division",
  "dl",
  "docinfo",
  "document-id",
  "doubleflat",
  "doublesharp",
  "edition",
  "editor",
  "eg",
  "ellipsis",
  "em",
  "email",
  "entity",
  "etal",
  "etc",
  "event",
  "example",
  "exercise",
  "exercisegroup",
  "exercises",
  "explanation",
  "exploration",
  "fact",
  "feedback",
  "figure",
  "fillin",
  "flat",
  "fn",
  "foreign",
  "fragment",
  "fragref",
  "frontmatter",
  "genus",
  "gi",
  "glossary",
  "h",
  "handout",
  "headnote",
  "heuristic",
  "hint",
  "historical",
  "holder",
  "hypothesis",
  "ibid",
  "icon",
  "identity",
  "idx",
  "ie",
  "image",
  "images",
  "index",
  "index-list",
  "init",
  "initialism",
  "input",
  "insert",
  "insight",
  "institution",
  "instruction",
  "instructions",
  "interactive",
  "interlude",
  "intertext",
  "introduction",
  "investigation",
  "iotest",
  "journal",
  "justification",
  "kbd",
  "keyword",
  "keywords",
  "langle",
  "latex",
  "latex-image",
  "latex-image-preamble",
  "ldblbracket",
  "lemma",
  "letter",
  "li",
  "line",
  "list",
  "list-of",
  "listing",
  "location",
  "lq",
  "lsq",
  "m",
  "macro-file",
  "macros",
  "mag",
  "match",
  "matches",
  "math-package",
  "md",
  "mdash",
  "mdn",
  "me",
  "memo",
  "men",
  "midpoint",
  "minilicense",
  "minus",
  "mrow",
  "myopenmath",
  "n",
  "name",
  "natural",
  "nb",
  "nbsp",
  "ndash",
  "notation",
  "notation-list",
  "note",
  "number",
  "numbering",
  "obelus",
  "objectives",
  "observation",
  "ol",
  "outcomes",
  "output",
  "p",
  "page",
  "pages",
  "paragraphs",
  "parsons",
  "part",
  "per",
  "permille",
  "personname",
  "pf",
  "pg-code",
  "pg-macros",
  "phonomark",
  "pilcrow",
  "plaintitle",
  "plusminus",
  "pm",
  "poem",
  "postamble",
  "postlude",
  "pre",
  "preamble",
  "preface",
  "prefigure",
  "prelude",
  "premise",
  "pretext",
  "prime",
  "principle",
  "problem",
  "program",
  "programs",
  "project",
  "prompt",
  "proof",
  "proposition",
  "ps",
  "publisher",
  "pubtitle",
  "q",
  "quantity",
  "question",
  "rangle",
  "rdblbracket",
  "reading-questions",
  "reasoning",
  "references",
  "registered",
  "remark",
  "rename",
  "response",
  "role",
  "row",
  "rq",
  "rsq",
  "sage",
  "sageplot",
  "sbsgroup",
  "scaledeg",
  "score",
  "section",
  "section-mark",
  "see",
  "seealso",
  "series",
  "servicemark",
  "sharp",
  "shortdescription",
  "shortlicense",
  "shorttitle",
  "sidebyside",
  "slate",
  "solidus",
  "solution",
  "solutions",
  "species",
  "sq",
  "stack",
  "stale",
  "stanza",
  "statement",
  "static",
  "stdin",
  "subexercises",
  "subsection",
  "subsubsection",
  "subtitle",
  "support",
  "swungdash",
  "table",
  "tabular",
  "tag",
  "tage",
  "task",
  "taxon",
  "technology",
  "term",
  "tests",
  "tex",
  "theorem",
  "timeofday",
  "times",
  "timesignature",
  "title",
  "titlepage",
  "titlepage-items",
  "today",
  "trademark",
  "ul",
  "unit",
  "url",
  "usage",
  "var",
  "video",
  "viz",
  "volume",
  "vs",
  "warning",
  "website",
  "webwork",
  "worksheet",
  "xelatex",
  "xetex",
  "xhtml:button",
  "xref",
  "year"
], y = Object.freeze(
  Object.keys(g)
), j = new Set(y), z = new Set(k);
function f(e) {
  return j.has(e);
}
function $(e) {
  return z.has(e);
}
function M() {
  return y;
}
function _() {
  return k;
}
function H() {
  return w;
}
function S(e) {
  return g[e].elements;
}
function E(e) {
  return g[e].attributes;
}
function R(e) {
  const i = [];
  function r(l, m) {
    if (l.type === "element") {
      const n = l.name;
      if (!f(n)) {
        i.push(`${m}: unknown PreTeXt element <${n}>`);
        return;
      }
      const d = new Set(
        E(n)
      ), o = l.attributes;
      for (const s of Object.keys(o ?? {}))
        d.has(s) || i.push(
          `${m}: attribute "${s}" is not allowed on <${n}> according to generated schema data`
        );
    }
    const x = l.children;
    if (!Array.isArray(x)) return;
    const c = l.type === "element" ? l.name : void 0, h = !c || !f(c) ? void 0 : new Set(
      S(c)
    );
    x.forEach((n, d) => {
      const o = n;
      if (o.type === "text" || o.type !== "element") return;
      const s = o, v = `${m}/${s.name}[${d}]`;
      h && !h.has(s.name) && i.push(
        `${m}: child <${s.name}> is not allowed inside <${c}> according to generated schema data`
      ), r(s, v);
    });
  }
  return r(e, e.type === "root" ? "root" : `<${e.name}>`), i;
}
function p(e) {
  return typeof e == "object" && e !== null && e.type === "element" && typeof e.name == "string";
}
function U(e) {
  return p(e) || typeof e == "object" && e !== null && e.type === "root" && Array.isArray(e.children);
}
function V(e) {
  return typeof e == "object" && e !== null && e.type === "text" && typeof e.value == "string";
}
function t(e) {
  return (i) => p(i) && i.name === e;
}
const B = t("title"), F = t("subtitle"), L = t("pretext"), X = t("book"), Q = t("article"), Y = t("frontmatter"), W = t("backmatter"), G = t("titlepage"), J = t("author"), K = t("part"), Z = t("chapter"), ee = t("section"), te = t("subsection"), ie = t("subsubsection"), ae = t("paragraphs"), le = t("appendix"), re = t("theorem"), se = t("lemma"), ne = t("corollary"), oe = t("proposition"), me = t("claim"), ce = t("fact"), be = t("conjecture"), pe = t("openconjecture"), ue = t("openproblem"), de = t("openquestion"), ge = t("axiom"), xe = t("principle"), he = t("hypothesis"), fe = t("definition"), ke = t("notation"), ye = t("remark"), qe = t("note"), ve = t("observation"), we = t("warning"), je = t("insight"), ze = t("example"), Se = t("question"), Ee = t("problem"), Pe = t("exercise"), Te = t("activity"), Ae = t("exploration"), Ne = t("investigation"), Ce = t("project"), Ie = t("demonstration"), Oe = t("task"), De = t("proof"), $e = t("solution"), Me = t("answer"), _e = t("hint"), He = t("case"), Re = t("statement"), Ue = t("algorithm"), Ve = t("assemblage"), Be = t("biblio"), Fe = t("listing"), Le = t("p"), Xe = t("blockquote"), Qe = t("pre"), Ye = t("ol"), We = t("ul"), Ge = t("li"), Je = t("dl"), Ke = t("figure"), Ze = t("table"), et = t("tabular"), tt = t("sidebyside"), it = t("sbsgroup"), at = (e) => p(e) && e.name === "image", lt = t("caption"), rt = t("description"), st = t("program"), nt = t("console"), ot = t("sage"), mt = t("stack"), ct = t("prompt"), bt = t("input"), pt = t("output"), ut = t("m"), dt = t("me"), gt = t("men"), xt = t("md"), ht = t("mdn"), ft = t("mrow"), kt = t("em"), yt = t("alert"), qt = t("term"), vt = t("c"), wt = t("q"), jt = t("sq"), zt = t("pubtitle");
function St(e) {
  return p(e) && e.name === "xref" && typeof e.attributes?.ref == "string";
}
const Et = t("url"), Pt = t("fn"), Tt = t("idx"), At = t("h");
function P(e) {
  return { type: "text", value: e };
}
function a(e, i, r) {
  return {
    type: "element",
    name: e,
    attributes: r ?? {},
    children: i
  };
}
function u(e, i, r) {
  return a(e, [P(i)], r);
}
function Nt(e) {
  return a("title", e);
}
function Ct(e) {
  return a("em", e);
}
function It(e) {
  return a("alert", e);
}
function Ot(e) {
  return a("term", e);
}
function Dt(e) {
  return u("c", e);
}
function $t(e) {
  return a("q", e);
}
function Mt(e) {
  return u("m", e);
}
function _t(e) {
  return u("me", e);
}
function Ht(e, i) {
  return u("men", e, i);
}
function Rt(e, i) {
  return a("xref", [], { ...i, ref: e });
}
function Ut(e, i) {
  return a("url", [], { href: e, ...i ? { visual: i } : {} });
}
function Vt(e) {
  return a("fn", e);
}
function Bt(e, i) {
  return a("p", e, i);
}
function Ft(e) {
  return a("li", e);
}
function Lt(e, i) {
  return a("ol", e, i);
}
function Xt(e, i) {
  return a("ul", e, i);
}
function Qt(e, i) {
  return a("chapter", e, i);
}
function Yt(e, i) {
  return a("section", e, i);
}
function Wt(e, i) {
  return a("subsection", e, i);
}
function Gt(e) {
  return a("statement", e);
}
function Jt(e, i) {
  return a("proof", e, i);
}
function Kt(e, i) {
  return a("solution", e, i);
}
function Zt(e, i) {
  return a("hint", e, i);
}
function ei(e, i) {
  return a("answer", e, i);
}
function ti(e, i) {
  return a("theorem", e, i);
}
function ii(e, i) {
  return a("lemma", e, i);
}
function ai(e, i) {
  return a("corollary", e, i);
}
function li(e, i) {
  return a("proposition", e, i);
}
function ri(e, i) {
  return a("definition", e, i);
}
function si(e, i) {
  return a("remark", e, i);
}
function ni(e, i) {
  return a("note", e, i);
}
function oi(e, i) {
  return a("warning", e, i);
}
function mi(e, i) {
  return a("example", e, i);
}
function ci(e, i) {
  return a("exercise", e, i);
}
function bi(e, i) {
  return a("assemblage", e, i);
}
const b = [
  "part",
  "chapter",
  "section",
  "subsection",
  "subsubsection",
  "paragraphs"
];
function T(e) {
  return b.includes(e);
}
const A = [
  "worksheet",
  "exercises",
  "references",
  "appendix",
  "glossary",
  "handout",
  "solutions",
  "reading-questions",
  "introduction",
  "conclusion"
];
function q(e) {
  return A.includes(e);
}
const N = [
  "introduction",
  "conclusion"
];
function C(e) {
  return N.includes(e);
}
function pi(e) {
  return T(e) || q(e);
}
function I(e, i) {
  if (C(e)) return "paragraphs";
  if (i <= 1) return e;
  if (e === "appendix") return I("chapter", i);
  if (q(e)) return "paragraphs";
  const l = b.indexOf(e) + (i - 1);
  return b[Math.min(l, b.length - 1)];
}
export {
  b as DIVISION_HIERARCHY,
  A as EXTRA_DIVISION_TYPES,
  O as PTX_VALUE_ELEMENT_NAMES,
  N as TITLELESS_DIVISION_TYPES,
  It as alert,
  ei as answer,
  bi as assemblage,
  Dt as c,
  Qt as chapter,
  R as collectPtxSchemaViolations,
  ai as corollary,
  ri as definition,
  I as divisionTypeAtRelativeDepth,
  Ct as em,
  mi as example,
  ci as exercise,
  Vt as fn,
  _ as getPtxCuratedElementNames,
  E as getPtxSchemaAttributeNames,
  S as getPtxSchemaChildElementNames,
  M as getPtxSchemaElementNames,
  D as getPtxTextContent,
  H as getPtxUnmodeledSchemaElementNames,
  Zt as hint,
  Te as isActivity,
  yt as isAlert,
  Ue as isAlgorithm,
  Me as isAnswer,
  le as isAppendix,
  Q as isArticle,
  Ve as isAssemblage,
  J as isAuthor,
  ge as isAxiom,
  W as isBackmatter,
  Be as isBiblio,
  Xe as isBlockquote,
  X as isBook,
  vt as isC,
  lt as isCaption,
  He as isCase,
  Z as isChapter,
  me as isClaim,
  be as isConjecture,
  nt as isConsole,
  ne as isCorollary,
  fe as isDefinition,
  Ie as isDemonstration,
  rt as isDescription,
  T as isDivisionType,
  Je as isDl,
  p as isElement,
  kt as isEm,
  ze as isExample,
  Pe as isExercise,
  Ae as isExploration,
  q as isExtraDivisionType,
  ce as isFact,
  Ke as isFigure,
  Pt as isFn,
  Y as isFrontmatter,
  At as isH,
  _e as isHint,
  he as isHypothesis,
  Tt as isIdx,
  at as isImage,
  bt as isInput,
  je as isInsight,
  Ne as isInvestigation,
  se as isLemma,
  Ge as isLi,
  Fe as isListing,
  ut as isM,
  xt as isMd,
  ht as isMdn,
  dt as isMe,
  gt as isMen,
  ft as isMrow,
  ke as isNotation,
  qe as isNote,
  ve as isObservation,
  Ye as isOl,
  pe as isOpenConjecture,
  ue as isOpenProblem,
  de as isOpenQuestion,
  pt as isOutput,
  Le as isP,
  ae as isParagraphs,
  U as isParent,
  K as isPart,
  Qe as isPre,
  L as isPretext,
  xe as isPrinciple,
  Ee as isProblem,
  st as isProgram,
  Ce as isProject,
  ct as isPrompt,
  De as isProof,
  oe as isProposition,
  $ as isPtxCuratedElementName,
  f as isPtxSchemaElementName,
  V as isPtxText,
  zt as isPubtitle,
  wt as isQ,
  Se as isQuestion,
  ye as isRemark,
  ot as isSage,
  it as isSbsgroup,
  ee as isSection,
  tt as isSidebyside,
  $e as isSolution,
  jt as isSq,
  mt as isStack,
  Re as isStatement,
  te as isSubsection,
  ie as isSubsubsection,
  F as isSubtitle,
  Ze as isTable,
  et as isTabular,
  Oe as isTask,
  qt as isTerm,
  re as isTheorem,
  B as isTitle,
  C as isTitlelessDivisionType,
  G as isTitlepage,
  pi as isTopLevelDivisionType,
  We as isUl,
  Et as isUrl,
  we as isWarning,
  St as isXref,
  ii as lemma,
  Ft as li,
  Mt as m,
  _t as me,
  Ht as men,
  ni as note,
  Lt as ol,
  Bt as p,
  Jt as proof,
  li as proposition,
  g as ptxSchemaElementChildren,
  $t as q,
  si as remark,
  Yt as section,
  Kt as solution,
  Gt as statement,
  Wt as subsection,
  Ot as term,
  P as text,
  ti as theorem,
  Nt as title,
  Xt as ul,
  Ut as url,
  oi as warning,
  Rt as xref
};
